export default __webpack_public_path__ + "static/media/service.e2c7d315.png";